<template>
	<div class="page-container">
		<head-top head-title="提现记录" goBack="true"></head-top>

		<div class="records-page">
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-empty v-if="!loading && finished && records.length === 0" description="暂无记录" />
				<van-list :offset="40" v-model="loading" :finished="finished" :immediate-check="false" :finished-text="finished ? '没有更多了~' : ''" @load="onLoad">
					
					<div class="record-card bg_a" v-for="item in records" :key="item.id">
						<div class="record-header flex_a">
							<van-icon name="alipay" class="account-icon" />
							<div>提现账号：{{ item.alipayAccount }}（{{item.realName}}）</div>
						</div>
						<div class="record-info flex_c">
							<div>提现金额：</div>
							<div class="record-amount">
								${{ item.amount }}
							</div>
						</div>
						
						<div class="record-info flex_c">
							<div>申请状态：</div>
							<div>{{ getStatusText(item.status) }}</div>
						</div>
						
						<div class="record-info flex_c">
							<div>申请时间：</div>
							<div>{{ item.applyTime||"-" }}</div>
						</div>
						
						<div class="record-info flex_c">
							<div>提现手续费：</div>
							<div class="record-amount" v-if="item.handlingFee">
								${{ item.handlingFee }}
							</div>
							<div v-else>-</div>
						</div>						
						
						<div class="record-info flex_c">
							<div>到账时间：</div>
							<div>{{ item.finishTime||"-" }}</div>
						</div>
						
						<div class="record-info flex_c">
							<div>交易流水号：</div>
							<div>{{ item.transactionNum||"-" }}</div>
						</div>
					</div>
					
				</van-list>
			</van-pull-refresh>
		</div>

		<div class="back-to-top" :class="{ show: showBackToTop }" @click="scrollToTop">
			<van-icon name="back-top" />
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import {
		getLoginMember,
		listWithdrawApply
	} from '@/apis/api.js'

	export default {
		name: 'Records',
		components: {
			headTop: headTop
		},
		data() {
			return {
				records: [],
				pageNum: 0,
				total: 0,
				pageSize: 10,
				loading: false,
				finished: false,
				refreshing: false,
				showBackToTop: false
			}
		},
		mounted() {
			if (!getLoginMember()) {
				this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
				return
			}
			this.getList()
			window.addEventListener('scroll', this.handleScroll)
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		methods: {
			getList() {
				this.pageNum++
				listWithdrawApply({
						pageNum: this.pageNum,
						pageSize: this.pageSize
					})
					.then(res => {
						const rows = res.rows || []
						this.total = res.total || 0
						this.records = this.records.concat(rows)
						if (this.records.length >= this.total) {
							this.finished = true
						} else {
							this.finished = false
						}
					})
					.catch(e => {
						this.finished = true
						if (!e.handled) {
							this.$toast('加载失败')
						}
					})
					.finally(() => {
						this.loading = false
						this.refreshing = false
					})
			},
			onLoad() {
				if (this.refreshing || this.finished) return
				this.getList()
			},
			onRefresh() {
				this.pageNum = 0
				this.records = []
				this.finished = false
				this.getList()
			},
			handleScroll() {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				this.showBackToTop = scrollTop > 300
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			},
			getStatusText(status) {
				const map = {
					0: '待审核',
					1: '待打款',
					2: '完成'
				}
				return map[status] !== undefined ? map[status] : '-'
			}

		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-top: 48px;

		.records-page {
			padding: 14px;

			.record-card {
				border-radius: 8px;
				padding: 14px;
				margin-bottom: 14px;

				.record-header {
					padding-bottom: 12px;
					border-bottom: 1px solid #e4e7ed;
					margin-bottom: 12px;
					color: #333;
					font-size: 14px;
					font-weight: bold;

					.account-icon {
						margin-right: 6px;
						color: #1778FF;
						font-size: 20px;
					}
				}

				.record-info {
					color: #333;
					font-size: 14px;
					line-height: 2;
					
					.record-amount {
						color: #e33737;
						font-size: 16px;
						font-weight: bold;
					}
				}
			}
		}

		.back-to-top {
			position: fixed;
			right: 20px;
			bottom: 90px;
			width: 44px;
			height: 44px;
			background: #ffffff;
			border-radius: 50%;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
			display: flex;
			align-items: center;
			justify-content: center;
			opacity: 0;
			visibility: hidden;
			transition: all 0.3s ease;
			z-index: 1000;
		
			&.show {
				opacity: 1;
				visibility: visible;
			}
		
			.van-icon {
				font-size: 24px;
				color: #444;
			}
		}
	}
</style>